@for (textDialogData of textDialogDataList; track textDialogDataList) {
	<div class="text {{ textDialogData.class }}">{{ textDialogData.content }}</div>
}
